import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import Icon from '../icon';
import { BottomSheetContext } from './BottomSheetContext';
import { BottomSheetButtonIcon } from './styles/bottom-sheet-button-icon.styled';
export const BottomSheetCloseButton = ({ dataTest = 'bottom-sheet-close-button', }) => {
    const { toggleBottomSheet } = useContext(BottomSheetContext);
    return (_jsx(BottomSheetButtonIcon, { color: "tertiary", onClick: () => {
            toggleBottomSheet(false);
        }, dataTest: dataTest, children: _jsx(Icon, { variant: "cross" }) }));
};
